export const enum LeadSignInStatsGtmLabelEnum {
  /**
   * After user have sent email lead
   */
  postEmailLead = 'Post Email Lead',

  /**
   * After user opened call popup
   */
  postCallLead = 'Post Call Lead',
}
